import React from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportNationalNotesFilters, getReportNationalNotesAction } from "redux/actions/Reports/reportNationalNotes/reportNationalNotesActions";

export const ReportNationalNotesView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportNationalNotes }) => reportNationalNotes);

  const handleSubmit = (e, isPdf = true) => {
    e.preventDefault()
    if (!station?.id) {
      setSnackbar("Falta planta.", 'warning');
      return;
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportNationalNotesAction({ startDate, endDate, station, isPdf }))
  };

  return (
    <GlobalBox title="Reporte de Notas Nacionales" icon={<AssessmentIcon />} >
      {isLoadingComp?.loadingReportNationalNotes ? <LoadingComponent /> :
        <TableInputs
          reducer="reportNationalNotes"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportNationalNotesFilters}
          submitAction={handleSubmit}
          submitButtonName="Descargar pdf"
        />
      }
    </GlobalBox>
  );
};
